export const tr = {
    'combinator-tab': 'Sözcük grubu birleştirici',
    'manual-input-tab': 'Manuel veri girişi'
};
